import React from 'react';
import { twMerge } from 'tailwind-merge';
import Button from '../../../buttons/Button';
import HoverButton from '../../../buttons/HoverButton';
import { BUTTON_STYLE, BUTTON_STYLE_COLLAPSE, LABEL_STYLE, LABEL_STYLE_COLLAPSE } from './style';

interface ActionProps {
  icon: JSX.Element;
  name: string;
  onClick: () => void;
  className?: string;
  textClassName?: string;
  open?: boolean;
}

export default function Action({
  name,
  icon,
  onClick,
  className,
  textClassName = '',
  open = false,
}: ActionProps) {
  return (
    <HoverButton className="w-full">
      <HoverButton.Button>
        <Button
          key={name}
          className={twMerge(BUTTON_STYLE, !open && BUTTON_STYLE_COLLAPSE, className)}
          onClick={onClick}>
          {icon}
          <p className={twMerge(LABEL_STYLE, !open && LABEL_STYLE_COLLAPSE, textClassName)}>
            {name}
          </p>
        </Button>
      </HoverButton.Button>
      {!open && (
        <HoverButton.Div className="transition-50 left-[150%] top-[50%] hidden -translate-y-[50%] rounded-[8px] bg-primary-900 px-3 py-2 group-[.collapsed]:block">
          <p className="whitespace-nowrap text-sm text-secondary-50">{name}</p>
          <div className="absolute -left-1 top-[50%] h-[15px] w-[15px] -translate-y-[50%] rotate-45 rounded-[2px] bg-primary-900" />
        </HoverButton.Div>
      )}
    </HoverButton>
  );
}
